import { connect } from 'react-redux';
import Modal from './index';
import { SendingNewPasswordRequest } from '../../../redux/actions/LoginActions';

const mapStateToProps = state => {
  return {
    state,
    loading: state.LoadingReducer.isLoading,
    internetCheck: state.LoginReducer.isNetConnected,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendingPasswordOnEmail: (emailId, callback) =>
      dispatch(SendingNewPasswordRequest(emailId, callback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
